/* eslint-disable */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { IEditFlowState } from '../../interfaces/state.interfaces';
import { IEditorTemplateData } from '../../interfaces/common.interface';

const initialState: IEditFlowState = {
    templateLoadingState: false,
    projectCreationStatus: false,
    adFromChat: null,
    adFromCreateTab: null,
    templateFromProject: null,
    refetchData: {
        refetchCampaignAds: false,
        refetchProjects: false,
    },
};

export const editFlowSlice = createSlice({
    name: 'editFlow',
    initialState,
    reducers: {
        SetTemplateLoadingState: (state, action: PayloadAction<boolean>) => {
            state.templateLoadingState = action.payload;
        },
        SetProjectCreationStatus: (state, action: PayloadAction<boolean>) => {
            state.projectCreationStatus = action.payload;
        },
        SetEditorTemplateData: (state, action: PayloadAction<IEditorTemplateData>) => {
            state.adFromChat = action.payload.adFromChat;
            state.adFromCreateTab = action.payload.adFromCreateTab;
            state.templateFromProject = action.payload.templateFromProject;
        },
        SetAdFromChatTemplateJSON: (state, action: PayloadAction<object | null>) => {
            if (state.adFromChat) {
                state.adFromChat.templateJSON = action.payload;
            }
        },
        SetAdFromChatTemplateExtraFields: (state, action: PayloadAction<object | null>) => {
            if (state.adFromChat) {
                state.adFromChat.templateExtraFields = action.payload;
            }
        },
        SetTemplateJSONForAdFromCreateTab: (state, action: PayloadAction<object | null>) => {
            if (state.adFromCreateTab) {
                state.adFromCreateTab.templateJSON = action.payload;
            }
        },
        SetTemplateJSONForTemplateFromProject: (state, action: PayloadAction<object | null>) => {
            if (state.templateFromProject) {
                state.templateFromProject.templateJSON = action.payload;
            }
        },
        SetCaptionForAdFromCreateTab: (state, action: PayloadAction<string>) => {
            if (state.adFromCreateTab) {
                state.adFromCreateTab.caption = action.payload;
            }
        },
        SetRefetchCampaignAds: (state, action: PayloadAction<boolean>) => {
            state.refetchData.refetchCampaignAds = action.payload;
        },
        SetRefetchProjects: (state, action: PayloadAction<boolean>) => {
            state.refetchData.refetchProjects = action.payload;
        },
        SetEditorInitialState: (state) => {
            state.templateLoadingState = false;
            state.projectCreationStatus = false;
            state.adFromChat = null;
            state.adFromCreateTab = null;
            state.templateFromProject = null;
            state.refetchData = {
                refetchCampaignAds: false,
                refetchProjects: false,
            };
        },
    },
});

export const {
    SetTemplateLoadingState,
    SetProjectCreationStatus,
    SetEditorTemplateData,
    SetAdFromChatTemplateJSON,
    SetAdFromChatTemplateExtraFields,
    SetTemplateJSONForAdFromCreateTab,
    SetTemplateJSONForTemplateFromProject,
    SetCaptionForAdFromCreateTab,
    SetRefetchCampaignAds,
    SetRefetchProjects,
    SetEditorInitialState,
} = editFlowSlice.actions;

export const editFlowReducer = editFlowSlice.reducer;
